import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { Ms365ApiAccessComponent } from './components/ms365-api-access/ms365-api-access.component';
import { Ms365PresenceMappingComponent } from './components/ms365-presence-mapping/ms365-presence-mapping.component';
import { Ms365SettingsPageComponent } from './components/ms365-settings-page/ms365-settings-page.component';
import { Ms365UserPresenceMappingComponent } from './components/ms365-user-presence-mapping/ms365-user-presence-mapping.component';

@NgModule({
  declarations: [
    Ms365SettingsPageComponent,
    Ms365PresenceMappingComponent,
    Ms365UserPresenceMappingComponent,
    Ms365ApiAccessComponent,
  ],
  imports: [CommonModule, SharedModule],
})
export class Ms365Module {}
